import traceActionsCreator from '../traceActionsCreator'

export const changeLanguageServiceName = 'Language/changeLanguage'
export const changeLanguageServiceNameActions = traceActionsCreator(
  changeLanguageServiceName
)
